import React, { useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { Unauthorized } from '../helpers/Unauthorized';
import { authContext } from '../Context/AuthContext';
import { cartContext } from '../Context/CartContext'; // Importá el contexto del carrito

export const Success = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { token } = useContext(authContext);
    const { emptyCart } = useContext(cartContext); // Extraé la función que vacía el carrito

    useEffect(() => {
        emptyCart(); // Limpiar el carrito al montar
    }, []);

    if (!token) return <Unauthorized />

    const props = location;
    const compra = props.state.param.pedidoFinal;

    return (
        <div className='divSuccess'>
            <h1>Muchas gracias por su compra</h1>
            <h4>Su pedido <span>{compra.Numero}/01</span> ha sido creado y procesado con éxito</h4>
            <h4>El vendedor asignado se comunicará con Ud. a fin de coordinar la entrega de la compra</h4>
            <Button variant="secondary" onClick={() => navigate('/')}>Volver al inicio</Button>
        </div>
    )
}